module.exports = __webpack_public_path__ + "img/prestige-privilege-active@3x-en.png";